<template>
  <section class="global-presence-section">
    <div class="section-container">

      <!-- 标题区域 -->
      <div class="header">
        <div class="tag">+ GLOBAL OPERATIONS</div>
        <h2 class="title">Our <span class="gradient">Global Presence</span></h2>

        <!-- 居中分割线 -->
        <div class="divider-container">
          <div class="line"></div>
          <span class="square-icon">[■]</span>
          <div class="line"></div>
        </div>
      </div>

      <!-- 主体内容区：左右两栏 -->
      <div class="content-wrapper">

        <!-- 左侧：柱状图区 -->
        <div class="chart-panel">
          <div class="chart-title">// CASES BY REGION</div>

          <div class="chart-list">
            <div v-for="region in regions" :key="region.name" class="chart-item">
              <div class="c-label">{{ region.name }}</div>
              <div class="c-bar-bg">
                <div class="c-bar-fill" :style="{ width: region.width + '%' }"></div>
              </div>
              <div class="c-value">{{ region.value }}</div>
            </div>
          </div>
        </div>

        <!-- 右侧：文本内容与标签区 -->
        <div class="content-area">
          <h3 class="feature-title">Serving Clients Across <span class="gradient">40+ Countries</span></h3>

          <p class="description">
            Cryptocurrency fraud operates without borders — and so do we. Our global network of enforcement contacts,
            regulatory relationships, and exchange partnerships means we can pursue stolen assets in any jurisdiction,
            on any blockchain, at any time.
          </p>
          <p class="description">
            From North America and Europe to Asia Pacific, the Middle East, and Africa — Fraud Counsel Department is
            trusted by clients worldwide to deliver results where local authorities cannot.
          </p>

          <!-- 国家标签云 -->
          <div class="tags-container">
            <div v-for="country in countries" :key="country" class="tag-item">
              <span class="tag-dot"></span> {{ country }}
            </div>
          </div>

          <button class="btn-action">⚡ GET HELP NOW</button>
        </div>

      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'GlobalPresence',
  data() {
    return {
      regions: [
        { name: 'NORTH AMERICA', value: '1,040', width: 100 },
        { name: 'EUROPE', value: '1,550', width: 85 },
        { name: 'ASIA PACIFIC', value: '1,280', width: 70 },
        { name: 'MIDDLE EAST', value: '840', width: 45 },
        { name: 'AFRICA', value: '580', width: 30 },
        { name: 'LATIN AMERICA', value: '400', width: 20 }
      ],
      countries: [
        'USA', 'UK', 'CANADA', 'AUSTRALIA', 'GERMANY', 'FRANCE',
        'SINGAPORE', 'UAE', 'NIGERIA', 'INDIA', 'JAPAN', 'BRAZIL',
        'SOUTH AFRICA', '+30 MORE'
      ]
    };
  }
}
</script>

<style scoped>
.global-presence-section {
  background-color: #070b14;
  padding: 60px 5%;
  color: #e2e8f0;
}

.section-container {
  max-width: 1400px;
  margin: 0 auto;
}

/* 标题区域 */
.header {
  position: relative;
  margin-bottom: 50px;
}

.tag {
  color: #4fd1c5;
  font-size: 0.75rem;
  letter-spacing: 2px;
  margin-bottom: 10px;
  font-weight: 500;
}

.title {
  font-size: 2.6rem;
  font-weight: 700;
  margin: 0 0 20px;
}

.gradient {
  background: linear-gradient(90deg, #4fd1c5, #8be9fd);
  -webkit-background-clip: text;
  color: transparent;
}

.divider-container {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}

.divider-container .line {
  flex: 1;
  height: 1px;
  background-color: rgba(79, 209, 197, 0.2);
}

.divider-container .square-icon {
  color: #4fd1c5;
  font-size: 0.8rem;
  font-family: monospace;
  margin: 0 15px;
}

/* 左右分栏 */
.content-wrapper {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 60px;
}

/* 左侧图表面板 */
.chart-panel {
  flex: 1;
  background: rgba(13, 17, 23, 0.8);
  border: 1px solid #253045;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}

.chart-title {
  color: #4fd1c5;
  font-family: monospace;
  font-size: 0.85rem;
  margin-bottom: 30px;
}

.chart-item {
  margin-bottom: 20px;
}

.c-label {
  color: #94a3b8;
  font-size: 0.75rem;
  margin-bottom: 6px;
}

.c-bar-bg {
  height: 6px;
  background: #1f2937;
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 6px;
}

.c-bar-fill {
  height: 100%;
  background: #4fd1c5;
  border-radius: 3px;
}

.c-value {
  color: #a0b3cc;
  font-size: 0.75rem;
  font-family: monospace;
  text-align: right;
}

/* 右侧文本区域 */
.content-area {
  flex: 1.2;
  padding-top: 20px;
}

.feature-title {
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 25px;
  color: #fff;
}

.description {
  color: #a0b3cc;
  font-size: 0.9rem;
  line-height: 1.8;
  margin-bottom: 20px;
}

/* 国家标签 */
.tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 40px;
  margin-top: 30px;
}

.tag-item {
  border: 1px solid #253045;
  background: #0a101f;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 0.75rem;
  font-weight: 600;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tag-dot {
  width: 6px;
  height: 6px;
  background: #4fd1c5;
  border-radius: 50%;
}

/* 按钮 */
.btn-action {
  background: linear-gradient(90deg, #4fd1c5, #8be9fd);
  color: #000;
  border: none;
  padding: 12px 24px;
  font-size: 0.9rem;
  font-weight: 700;
  border-radius: 6px;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
  box-shadow: 0 0 15px rgba(79, 209, 197, 0.3);
}

.btn-action:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 20px rgba(79, 209, 197, 0.4);
}

/* 响应式适配 */
@media (max-width: 900px) {
  .content-wrapper {
    flex-direction: column;
  }

  .chart-panel,
  .content-area {
    width: 100%;
  }

  .title {
    font-size: 2rem;
  }

  .feature-title {
    font-size: 1.4rem;
  }
}
</style>